import { api } from "../lib/api";

export const list = ({ includeInactive = false, type = "", search = "" } = {}) =>
  api.get("/tenant/machine-catalog", {
    params: {
      include_inactive: includeInactive,
      type: type || undefined,
      search: search || undefined,
    },
  }).then((response) => response.data);

export const create = (payload) =>
  api.post("/tenant/machine-catalog", payload).then((response) => response.data);

export const update = (id, payload) =>
  api.put(`/tenant/machine-catalog/${id}`, payload).then((response) => response.data);

export const archive = (id) =>
  api.delete(`/tenant/machine-catalog/${id}`).then((response) => response.data);

export const uploadPhoto = (id, file) => {
  const body = new FormData();
  body.append("file", file);
  return api.post(`/tenant/machine-catalog/${id}/photo`, body).then((r) => r.data);
};

export const deletePhoto = (id) =>
  api.delete(`/tenant/machine-catalog/${id}/photo`).then((r) => r.data);
